import { electronicFormatIBAN, isValidIBAN } from "ibantools";

export const isValidIban =
  () =>
  (value: string): boolean =>
    isValidIBAN(electronicFormatIBAN(value) ?? value);
